import {
  generateItemsReducer,
  generateItemAndActionsFromStore,
  generateItemListAndActionsFromStore,
} from "./item";

const itemType = "document";
const endpoint = "documents/";

export const documentsReducer = generateItemsReducer<DocumentSnakeModel, {}>(itemType);

export const documentAndActionsFromStore = generateItemAndActionsFromStore<DocumentSnakeModel, {}, {}>(
  itemType,
  endpoint,
  (a, b, c, d) => ({}),
);

export const documentListAndActionsFromStore = generateItemListAndActionsFromStore(itemType, documentAndActionsFromStore);

